import { render, staticRenderFns } from "./sysMsg.vue?vue&type=template&id=f9a3e63c&lang=pug&"
import script from "./sysMsg.vue?vue&type=script&lang=js&"
export * from "./sysMsg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports